module.exports = __webpack_public_path__ + "img/diagram-lean-canvas.69682bd6.svg";